import React from 'react';
import PageSection from '../../components/PageSection';
import DataTable from '../../components/DataTable';
import RawJsonDisplay from '../../components/RawJsonDisplay';
import { TenantInfo } from 'types';
import { OrgContextLink } from 'components/OrgContextProvider';

interface TenantsListContainerProps {
	tenants: TenantInfo[];
	onChanged: () => void;
}

const TenantsListContainer = ({ tenants, onChanged }: TenantsListContainerProps) => {
	const deleteTenant = (tenant: TenantInfo) => {
		if (window.confirm(`Delete tenant ${tenant.name}?`)) {
			fetch(`/api/tenants/${tenant.id}`, { method: 'DELETE' })
			.then(() => onChanged());
		}
	};

	return (
		<div>
			<PageSection title="Tenants" level={1}>
				<DataTable<TenantInfo>
					data={tenants}
					columns={[
						{ label: 'Name', key: 'name', render: (tenant) => <OrgContextLink to={"/settings/tenants/" + tenant.id}>{tenant.name}</OrgContextLink> },
						{ label: 'ID', key: 'id' }
					]}
					tools={[
						{ label: 'Delete', action: (tenant) => deleteTenant(tenant) }
					]}
					tableTools={[
						{ label: 'Create New Tenant...', render: () => <OrgContextLink to="/settings/tenants/new">Create New Tenant...</OrgContextLink> }
					]}
				/>
			</PageSection>

			<PageSection title="Raw Data" level={2}>
				<RawJsonDisplay data={tenants} />
			</PageSection>
		</div>
	);
}

export default TenantsListContainer;
